import { render, staticRenderFns } from "./HomepageRemittance.vue?vue&type=template&id=13c4a23c&scoped=true&"
import script from "./HomepageRemittance.vue?vue&type=script&lang=js&"
export * from "./HomepageRemittance.vue?vue&type=script&lang=js&"
import style0 from "./HomepageRemittance.vue?vue&type=style&index=0&id=13c4a23c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c4a23c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13c4a23c')) {
      api.createRecord('13c4a23c', component.options)
    } else {
      api.reload('13c4a23c', component.options)
    }
    module.hot.accept("./HomepageRemittance.vue?vue&type=template&id=13c4a23c&scoped=true&", function () {
      api.rerender('13c4a23c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/HomepageRemittance.vue"
export default component.exports